import React, { useContext, useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import { MiFooter } from "../../components/footer/MiFooter";
import HeaderHome from "../../components/headerHome/HeaderHome"
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { useSessionStore } from "../../hooks/useSessionStore";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { BannerMarket } from "../../components/home/BannerMarket";
import { SectionZero } from "../../components/home/SectionZero";
import {SectionOneCliente} from "../../components/home/SectionOneCliente";
import axios from 'axios';
import { Helmet } from "react-helmet";
import { SectionCuidatia } from "../../components/home/SectionCuidatia";

export const Cuidados = () => {
  const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
  /* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
  /* Destructuring the context. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  //const [Usuario, setUsuario] = useSessionStore({ Usuario: "Usuario" });
  const [autLocalidades, setAutLocalidades] = useState(false);
  ;

  /* Declaring a state variable called `MenuNoHayEmpresa` and initializing it with the value `false`.
  It also declares a function called `setMenuNoHayEmpresa` that can be used to update the value of
  `MenuNoHayEmpresa`. This state variable is likely used to control the display of a menu or message
  when there are no companies available in the marketplace. */
  const [MenuNoHayEmpresa, setMenuNoHayEmpresa] = useState(false);

	const [ btnSelected, setBtnSelected ] = useState();

  // El estado Empresas almacena la lista de empresas.
  const [Empresas, setEmpresas] = useState([]);
  const [empresasCargadas, setEmpresasCargadas] = useState([])

  const [ limite, setLimite ] = useState(18)
  const [ buscarNombre, setBuscarNombre ] = useState()
  const [ buscarCategoria, setBuscarCategoria ] = useState()
  const [ categoriaSeleccionada, setCategoriaSeleccionada ] = useState()
  const [ buscarLocalidad, setBuscarLocalidad ] = useState(0)
  const [ buscarProvincia, setBuscarProvincia ] = useState()

  const [ModalCafeRural, setModalCafeRural] = useState()

  const navigate = useNavigate()

  const [Mapa, setMapa] = useState(false);

  // El estado FiltroCategorias almacena el ID de la categoría a filtrar.
  const [FiltroCategorias, setFiltroCategorias] = useState();

  const [ModalUbiacion, setModalUbiacion] = useState(false);
  const [SeleccionUbicacion, setSeleccionUbicacion] = useState(false);
  const [Ubicacion, setUbicacion] = useState({
      lat: 40.41831,
      lng: -3.70275,
  });
  const [RadioUbicacion, setRadioUbicacion] = useState(0);

  const [zoom, setZoom] = useState(9);

  useEffect(() => {
    const modalSeen = sessionStorage.getItem('modalCafeRuralSeen');
    if (!modalSeen) {
      setModalCafeRural(true);
      sessionStorage.setItem('modalCafeRuralSeen', 'true');
    }
  }, []);

  /**
   * Recupera los detalles de una empresa a partir de su ID.
   * @param {number} id - El ID de la empresa a buscar.
   * @returns {Promise<Object>} Una promesa que resuelve con un objeto que contiene los detalles de la empresa.
   */
  const getEmpresa = async (id) => {
    try {
      const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/" + id + "/");
      const empresa = response.data;
      // Recupera la imagen de perfil de la empresa y crea una URL para ella.
      let imagenURL = "";
      try {
        const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
          responseType: "blob"
        });
        imagenURL = URL.createObjectURL(imagenResponse.data);
        return ({ ...empresa, img: imagenURL });
      } catch (error) {
        imagenURL = window.ipdirection + "CuidatiaNuevo2026.68c5966743354987255d.png";
        return ({ ...empresa, img: imagenURL });
      }
      // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
    } catch (error) {
      console.log(error);
    }
  };

  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      let location_scroll = location.hash.split('#')
      const section = document.getElementById(location_scroll[1]);
      if (section) {
        section.scrollIntoView({ behavior: 'auto' });
      }
    }
  }, [location]);


  /**
 * Recupera una lista de empresas a partir de una categoría dada.
 * @param {number} id - El ID de la categoría a buscar.
 * @returns {Promise<void>} Una promesa que resuelve cuando la lista de empresas ha sido recuperada.
 */
  useEffect(() => {
    // setBuscarCategoria(buscarCategoria)
    setBuscarCategoria(categoriaSeleccionada)
  },[categoriaSeleccionada])

  useEffect(() => {
    // setBuscarCategoria(buscarCategoria)
    if(categoriaSeleccionada != ''){
      // getEmpresas_preRegistradas()
      setCategoriaSeleccionada('')
    }
  },[buscarCategoria])
    



  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
    if (autLocalidades) {
      setAutLocalidades(false);
    }

  }

  /* A hook that is executed when the component is mounted. */
  const [OverleyModal, setOverleyModal] = useState("true");

  /* A hook that is executed when the component is mounted. */
  useEffect(() => {
    const cookiePrivacidad = new Cookies();
    (cookiePrivacidad.get("estado") === undefined) ? setOverleyModal("false") : setOverleyModal(cookiePrivacidad.get("estado"))
  }, [])

  /**
   * It sets the cookie to the value of the parameter cerrar.
   */
  const cerrarPrivacidad = (cerrar) => {
    const cookiePrivacidad = new Cookies();
    console.log(OverleyModal)
    cookiePrivacidad.set("estado", true)
    setOverleyModal(true)
  }



  const getImagenEmpresa = (id, lista, empresa) => {
    axios({
      method: "get",
      url: window.ipdirection + "imagenPerfilEmpresaCliente/" + id + "/",
      responseType: 'blob'
    }).then(response => {
      let newArray = [...Empresas]
      newArray.push({ ...empresa, img: URL.createObjectURL(response.data) })
      setEmpresas(newArray)
    });
  }

  /**
 * Recupera la lista de empresas y sus imágenes de perfil.
 * Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
 * @returns {Promise<void>}
 */
  const getEmpresas = async () => {
    try {
      // Recupera la lista de empresas.
      const response = await axios.get(window.ipdirection + "prestadorServiciosCliente/");
      const empresas = response.data;

      // Crea una promesa por cada empresa para recuperar su imagen de perfil y crear una URL.
      const empresasConImagenes = await Promise.all(
        empresas.map(async empresa => {
          try {

            const imagenResponse = await axios.get(window.ipdirection + `imagenPerfilEmpresaCliente/${empresa.id}/`, {
              responseType: "blob"
            });
            const imagenURL = URL.createObjectURL(imagenResponse.data);
            // Devuelve un objeto que contiene los detalles de la empresa y la URL de su imagen de perfil.
            return { ...empresa, img: imagenURL };
          } catch (error) {
            return { ...empresa, img: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images" };
          }
        })
      );

      // Actualiza el estado Empresas con la lista de empresas que incluyen sus imágenes de perfil.
      setEmpresas(empresasConImagenes);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmpresas_preRegistradas = async () => {
    // const response = await axios.get(window.ipdirection + "prestadorServiciosPreCargados/?limite="+limite);
    
    const response = await axios.get(window.ipdirection + "BusquedaAvanzada_PreRegistrados/?nombreEmpresa="+buscarNombre+"&categoria_id="+buscarCategoria+'&categoria_nombre=' +buscarNombre+"&localidad_id="+buscarLocalidad+"&provincia_id="+buscarProvincia+"&limite="+limite,)
    const empresasCargadasList = response.data
    const empresasCargadasConImagenes = await Promise.all(
      empresasCargadasList.map(async empresa => {
        const imagenDefault = "https://cdn-icons-png.flaticon.com/512/883/883360.png";

          return { ...empresa, img: imagenDefault};
      })
    );
    setEmpresasCargadas(empresasCargadasConImagenes)
  }


  // El estado MenuLateralAux indica si el menú lateral está abierto o cerrado.
  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  };


return (
    <>
    <Helmet>
      <title>Cuidatia | Encuentra los mejores servicios de cuidado a domicilio</title>
      <link rel="canonical" href="https://www.cuidatia.org/" />
    </Helmet>
    <Modal centered={true} isOpen={MenuNoHayEmpresa}>
      <ModalHeader>
        <div className='titulo-modal'>
          No hay empresas en esta categoría
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='descripcion-servicio descripcion-modal'>
          Todavia no hay empresas asociadas a esta categoría.
        </div>
      </ModalBody>
      <ModalFooter>
        <div className='centradorRight'>
          <div className='button' onClick={() => setMenuNoHayEmpresa(false)}><b>Aceptar</b></div>
        </div>
      </ModalFooter>
    </Modal>

    {}

    {/* <MenuLateralAB seleccionado={15} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} /> */}
    <div onClick={closeMenu} Id="Market">
      {
        OverleyModal === "false" && <Modal
          cerrarPrivacidad={cerrarPrivacidad}
        />
      }
      <div className="headerMiPerfil"  >
        <HeaderHome
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="body" Id="bodyMarket1" >
      {/* <BuscadorHome
          Empresas={Empresas}
          setEmpresas={setEmpresas}
          mapa={Mapa}
          setMapa={setMapa}
          setModalUbiacion={setModalUbiacion}
          setEmpresasCargadas={setEmpresasCargadas}
          getEmpresas_preRegistradas={getEmpresas_preRegistradas}
          setBuscarNombre={setBuscarNombre}
          setBuscarCategoria={setBuscarCategoria}
          setBuscarLocalidad={setBuscarLocalidad}
          setBuscarProvincia={setBuscarProvincia}
          limite={limite}
        /> */}
        <BannerMarket 
          Empresas={Empresas}
          setEmpresas={setEmpresas}
          mapa={Mapa}
          setMapa={setMapa}
          setModalUbiacion={setModalUbiacion}
          setEmpresasCargadas={setEmpresasCargadas}
          getEmpresas_preRegistradas={getEmpresas_preRegistradas}
          setBuscarNombre={setBuscarNombre}
          setBuscarCategoria={setBuscarCategoria}
          setBuscarLocalidad={setBuscarLocalidad}
          setBuscarProvincia={setBuscarProvincia}
                  chageMenuLateralAux={chageMenuLateralAux}
                />
                <SectionZero />
                <SectionOneCliente />
                  <div className="fooderMarket">
                        <MiFooter />
                      </div>
                
              </div>
            </div>
            </>
          );
        }
        
        export default Cuidados;